import React, { useEffect } from "react";
import style from "./TermsAndConditions.module.css";
import Icon from "@/ui/icon/Icon";
import Container from "@/layouts/container/Container";
import { Link } from "react-router-dom";
import Logo from "@/ui/logo/Logo";
import Footer from "@/layouts/footer/Footer";

function TermsAndConditions() {
	return (
		<>
			<Container size="mini">
				<div className={style.grid}>
					<div className={`${style.container} prose`}>
						<div className={style.header}>
							<div className={style.subHeader}>
								<Logo />
								<div className={style.nav}>
									<Link to="../">
										<Icon icon="fa-arrow-left" />
										<span>Nazad</span>
									</Link>
									<Icon icon="fa-slash-forward" />
									<Link to="/privacy-policy">
										<span>Politika privatnosti</span>
										<Icon icon="fa-arrow-right" />
									</Link>
								</div>
							</div>

							<h1>Opći uslovi korištenja</h1>
							<p>za digitalnu obrazovnu platformu Mentorios</p>
							<div className={style.date}>
								<div className={style.line}></div>
								<span>Ažurirano:</span>
								<span>Februar 2026.</span>
							</div>
						</div>

						<section id="general-info" data-section="general-info">
							<ol start="1">
								<li>
									<h2>Opće informacije o platformi</h2>
								</li>
							</ol>
							<p>
								Korištenje usluga i sadržaja internet stranice{" "}
								<a href="https://www.mentorios.com">
									www.mentorios.com
								</a>{" "}
								(u daljem tekstu: „Platforma" ili „Mentorios")
								omogućava Vam kompanija Pin d.o.o. Sarajevo, u
								skladu sa ovim Općim uslovima korištenja,
								Politikom privatnosti i Politikom kolačića (u
								daljem tekstu zajednički: „Uslovi").
							</p>
							<p>
								Web stranica{" "}
								<a href="https://www.mentorios.com">
									www.mentorios.com
								</a>{" "}
								je vlasništvo privrednog društva:
							</p>
							<p>
								<strong>Pin d.o.o. Sarajevo</strong>
								<br />
								Ismeta Alajbegovića Šerbe 3<br />
								71000 Sarajevo, Bosna i Hercegovina
								<br />
								MBS: 65-01-0773-13
								<br />
								ID: 4201923640002
								<br />
								PDV: 201923640002
								<br />
								E-mail: mentoriosedu@gmail.com
								<br />
								Web:{" "}
								<a href="https://www.mentorios.com">
									www.mentorios.com
								</a>
							</p>
							<p>
								Ovi Uslovi primjenjuju se na sve korisnike
								platforme Mentorios.
							</p>
						</section>

						<section id="definitions" data-section="definitions">
							<ol start="2">
								<li>
									<h2>Definicije</h2>
								</li>
							</ol>
							<ul>
								<li>
									<strong>Korisnik</strong> – svako fizičko
									lice koje pristupa ili koristi Mentorios
									platformu.
								</li>
								<li>
									<strong>Učenik</strong> – korisnik koji
									koristi platformu u svrhu učenja.
								</li>
								<li>
									<strong>Roditelj/Staratelj</strong> – lice
									koje daje saglasnost za korištenje platforme
									maloljetnom korisniku.
								</li>
								<li>
									<strong>Sadržaj</strong> – video lekcije,
									tekstovi, testovi, AI alati, grafike, baze
									znanja i ostali materijali.
								</li>
							</ul>
						</section>

						<section id="acceptance" data-section="acceptance">
							<ol start="3">
								<li>
									<h2>Prihvatanje uslova</h2>
								</li>
							</ol>
							<p>
								Korištenjem platforme Mentorios smatra se da ste
								pročitali, razumjeli i prihvatili ove Uslove.
							</p>
							<p>
								Ako se ne slažete sa bilo kojim dijelom Uslova,
								molimo vas da ne koristite platformu.
							</p>
						</section>

						<section id="age-capacity" data-section="age-capacity">
							<ol start="4">
								<li>
									<h2>Starosna dob i poslovna sposobnost</h2>
								</li>
							</ol>
							<p>Platformu mogu koristiti:</p>
							<ul>
								<li>Lica starija od 18 godina</li>
								<li>
									Maloljetna lica uz saglasnost roditelja ili
									staratelja
								</li>
							</ul>
							<p>
								Pin d.o.o. ne snosi odgovornost za neovlašteno
								korištenje platforme od strane maloljetnika bez
								saglasnosti roditelja/staratelja.
							</p>
						</section>

						<section id="purpose" data-section="purpose">
							<ol start="5">
								<li>
									<h2>Namjena platforme</h2>
								</li>
							</ol>
							<p>
								Mentorios je digitalna obrazovna platforma
								namijenjena:
							</p>
							<ul>
								<li>Učenju i edukaciji</li>
								<li>Pristupu nastavnim sadržajima</li>
								<li>Korištenju AI asistencije</li>
								<li>Praćenju napretka učenika</li>
							</ul>
							<p>
								Platforma ne predstavlja zamjenu za formalni
								obrazovni sistem, već dodatni obrazovni alat.
							</p>
						</section>

						<section id="registration" data-section="registration">
							<ol start="6">
								<li>
									<h2>Registracija i korisnički nalozi</h2>
								</li>
							</ol>
							<p>
								Korisnik je odgovoran za tačnost podataka
								prilikom registracije.
							</p>
							<p>
								Korisnik je dužan čuvati povjerljivost
								korisničkog imena i lozinke.
							</p>
							<p>
								Mentorios zadržava pravo suspendovati ili
								ugasiti nalog u slučaju:
							</p>
							<ul>
								<li>Zloupotrebe sistema</li>
								<li>Kršenja zakona</li>
								<li>Kršenja ovih Uslova</li>
							</ul>
						</section>

						<section
							id="subscriptions"
							data-section="subscriptions"
						>
							<ol start="7">
								<li>
									<h2>Pretplate i plaćanje</h2>
								</li>
							</ol>
							<p>
								Mentorios može nuditi besplatan i plaćeni
								pristup određenim sadržajima i
								funkcionalnostima.
							</p>
							<p>
								Vrste pretplata, trajanje, cijene i obim usluga
								biće jasno naznačeni na platformi.
							</p>
							<p>
								Sve cijene su izražene u konvertibilnim markama
								(KM) i uključuju PDV, osim ako nije drugačije
								naznačeno.
							</p>
							<p>Plaćanje se može vršiti isključivo putem:</p>
							<ul>
								<li>
									Platnih kartica (Visa, MasterCard i druge
									podržane kartice)
								</li>
								<li>Google Pay</li>
								<li>Apple Pay</li>
							</ul>
							<p>
								Kupac je dužan osigurati tačnost podataka za
								plaćanje.
							</p>
							<p>
								Mentorios zadržava pravo izmjene cijena
								pretplate uz prethodnu objavu na platformi.
							</p>
						</section>

						<section id="refunds" data-section="refunds">
							<ol start="8">
								<li>
									<h2>
										Povrat sredstava i otkazivanje pretplate
									</h2>
								</li>
							</ol>
							<p>
								Korisnik može otkazati pretplatu u bilo kojem
								trenutku putem korisničkog naloga.
							</p>
							<p>
								U slučaju otkazivanja, pristup plaćenim
								sadržajima ostaje aktivan do isteka obračunskog
								perioda.
							</p>
							<p>Povrat sredstava se vrši samo u slučajevima:</p>
							<ul>
								<li>Tehničke greške sistema</li>
								<li>Neovlaštenog terećenja</li>
							</ul>
							<p>
								Zahtjev za povrat se šalje na:{" "}
								<a href="mailto:mentoriosedu@gmail.com">
									mentoriosedu@gmail.com
								</a>
							</p>
						</section>

						<section
							id="intellectual-property"
							data-section="intellectual-property"
						>
							<ol start="9">
								<li>
									<h2>Intelektualno vlasništvo</h2>
								</li>
							</ol>
							<p>
								Svi sadržaji na platformi su vlasništvo Pin
								d.o.o. ili njegovih partnera.
							</p>
							<p>Zabranjeno je:</p>
							<ul>
								<li>Kopiranje</li>
								<li>Distribucija</li>
								<li>Reprodukcija</li>
								<li>
									Javno prikazivanje bez pismene saglasnosti
								</li>
							</ul>
							<p>
								Kršenje prava intelektualnog vlasništva
								podliježe zakonskoj odgovornosti.
							</p>
						</section>

						<section id="liability" data-section="liability">
							<ol start="10">
								<li>
									<h2>
										Odgovornost i odricanje odgovornosti
									</h2>
								</li>
							</ol>
							<p>Platforma se koristi na vlastitu odgovornost.</p>
							<p>
								Pin d.o.o. ne garantuje neprekidan rad platforme
								niti potpunu bezgrešnost sadržaja.
							</p>
							<p>Pin d.o.o. nije odgovoran za:</p>
							<ul>
								<li>Privremene prekide rada</li>
								<li>Gubitak podataka</li>
								<li>Tehničke greške</li>
							</ul>
						</section>

						<section id="changes" data-section="changes">
							<ol start="11">
								<li>
									<h2>Izmjene uslova</h2>
								</li>
							</ol>
							<p>
								Pin d.o.o. zadržava pravo izmjene ovih Uslova u
								bilo kojem trenutku.
							</p>
							<p>
								Izmjene stupaju na snagu objavom na platformi.
							</p>
						</section>

						<h2 style={{ marginTop: "3rem" }}>
							Politika privatnosti
						</h2>

						<section
							id="data-collection"
							data-section="data-collection"
						>
							<ol start="12">
								<li>
									<h2>Prikupljanje podataka</h2>
								</li>
							</ol>
							<p>
								Prikupljamo samo podatke nužne za pružanje
								usluge, uključujući:
							</p>
							<ul>
								<li>Ime i prezime</li>
								<li>E-mail</li>
								<li>Podatke o korištenju platforme</li>
								<li>IP adresu</li>
							</ul>
						</section>

						<section id="data-purpose" data-section="data-purpose">
							<ol start="13">
								<li>
									<h2>Svrha obrade podataka</h2>
								</li>
							</ol>
							<p>Podaci se koriste radi:</p>
							<ul>
								<li>Kreiranja naloga</li>
								<li>Funkcionisanja platforme</li>
								<li>Poboljšanja usluga</li>
								<li>Komunikacije sa korisnicima</li>
							</ul>
						</section>

						<section id="legal-basis" data-section="legal-basis">
							<ol start="14">
								<li>
									<h2>Pravni osnov obrade</h2>
								</li>
							</ol>
							<p>Obrada se vrši u skladu sa:</p>
							<ul>
								<li>Zakonom o zaštiti ličnih podataka BiH</li>
								<li>GDPR principima gdje je primjenjivo</li>
							</ul>
						</section>

						<section
							id="data-retention"
							data-section="data-retention"
						>
							<ol start="15">
								<li>
									<h2>Čuvanje podataka</h2>
								</li>
							</ol>
							<p>
								Podaci se čuvaju samo onoliko dugo koliko je
								neophodno za svrhu obrade.
							</p>
						</section>

						<section id="user-rights" data-section="user-rights">
							<ol start="16">
								<li>
									<h2>Prava korisnika</h2>
								</li>
							</ol>
							<p>Korisnik ima pravo da:</p>
							<ul>
								<li>Zatraži pristup podacima</li>
								<li>Zatraži ispravku</li>
								<li>Zatraži brisanje</li>
								<li>Povuče saglasnost</li>
							</ul>
							<p>
								Zahtjevi se šalju na:{" "}
								<a href="mailto:mentoriosedu@gmail.com">
									mentoriosedu@gmail.com
								</a>
							</p>
						</section>

						<section id="data-sharing" data-section="data-sharing">
							<ol start="17">
								<li>
									<h2>Dijeljenje podataka</h2>
								</li>
							</ol>
							<p>Podaci se ne dijele trećim stranama osim:</p>
							<ul>
								<li>Hosting provajderima</li>
								<li>IT partnerima</li>
								<li>Kada je zakonski obavezno</li>
							</ul>
						</section>

						<section
							id="data-security"
							data-section="data-security"
						>
							<ol start="18">
								<li>
									<h2>Sigurnost podataka</h2>
								</li>
							</ol>
							<p>
								Primjenjujemo tehničke i organizacijske mjere
								zaštite:
							</p>
							<ul>
								<li>Enkripcija</li>
								<li>Kontrola pristupa</li>
								<li>Sigurni serveri</li>
							</ul>
						</section>

						<h2 style={{ marginTop: "3rem" }}>Politika kolačića</h2>

						<section id="cookies-what" data-section="cookies-what">
							<ol start="19">
								<li>
									<h2>Šta su kolačići</h2>
								</li>
							</ol>
							<p>
								Kolačići su male datoteke koje se pohranjuju na
								vaš uređaj.
							</p>
						</section>

						<section
							id="cookies-types"
							data-section="cookies-types"
						>
							<ol start="20">
								<li>
									<h2>Vrste kolačića</h2>
								</li>
							</ol>
							<h3>Neophodni kolačići</h3>
							<p>Za osnovno funkcionisanje platforme.</p>
							<h3>Analitički kolačići</h3>
							<p>
								Za mjerenje posjećenosti i poboljšanje usluge.
							</p>
							<h3>Funkcionalni kolačići</h3>
							<p>Pamte vaše postavke.</p>
							<h3>Marketinški kolačići</h3>
							<p>Za prikaz prilagođenog sadržaja.</p>
						</section>

						<section
							id="cookies-retention"
							data-section="cookies-retention"
						>
							<ol start="21">
								<li>
									<h2>Rok čuvanja</h2>
								</li>
							</ol>
							<ul>
								<li>Neophodni: do zatvaranja sesije</li>
								<li>
									Analitički i funkcionalni: do 12 mjeseci
								</li>
								<li>Marketinški: do 6 mjeseci</li>
							</ul>
						</section>

						<section
							id="cookies-management"
							data-section="cookies-management"
						>
							<ol start="22">
								<li>
									<h2>Upravljanje kolačićima</h2>
								</li>
							</ol>
							<p>
								Korisnik može upravljati kolačićima putem
								postavki preglednika ili na platformi.
							</p>
						</section>

						<section
							id="final-provisions"
							data-section="final-provisions"
						>
							<h2>Završne odredbe</h2>
							<p>
								Na sve sporove primjenjuje se pravo Bosne i
								Hercegovine.
							</p>
							<p>Nadležan sud: Sud u Sarajevu.</p>
							<p>
								Za pitanja:{" "}
								<a href="mailto:mentoriosedu@gmail.com">
									mentoriosedu@gmail.com
								</a>
							</p>
						</section>
					</div>
				</div>
			</Container>
			<Footer />
		</>
	);
}

export default TermsAndConditions;
